import { supabase } from './supabase';

// Returns true if the given user id has a row in the admins table.
// RLS allows a user to read their OWN admin row, so this works
// client-side without elevated privileges.
export async function isAdmin(userId) {
  if (!userId) return false;
  const { data, error } = await supabase
    .from('admins').select('user_id').eq('user_id', userId).maybeSingle();
  if (error) return false;
  return !!data;
}

// Append-only ledger of admin actions.
export async function logAdminAction({ adminId, adminEmail, action, targetType, targetId, targetEmail, details }) {
  return supabase.from('admin_audit_log').insert({
    admin_id: adminId,
    admin_email: adminEmail,
    action,
    target_type: targetType,
    target_id: targetId,
    target_email: targetEmail,
    details: details || null,
  });
}

// Triggers Supabase's standard reset-password email. Same call the
// public 'Forgot password' form uses — no service role required.
export async function sendPasswordReset({ email, redirectTo }) {
  return supabase.auth.resetPasswordForEmail(email, {
    redirectTo: redirectTo || `${window.location.origin}/reset-password`,
  });
}

// Suspend/unsuspend act on the user_suspensions table. The Login
// flow reads this after auth.signIn succeeds; if a row exists for
// the user, it signs them back out and shows a 'suspended' notice.
export async function suspendUser({ userId, email, reason, adminId }) {
  return supabase.from('user_suspensions').upsert({
    user_id: userId,
    email,
    reason: reason || null,
    suspended_by: adminId,
    suspended_at: new Date().toISOString(),
  });
}

export async function unsuspendUser({ userId }) {
  return supabase.from('user_suspensions').delete().eq('user_id', userId);
}

// Read THIS user's own suspension row (relies on the self_select RLS
// policy). Returns the suspension row or null.
export async function getMySuspension(userId) {
  if (!userId) return null;
  const { data } = await supabase
    .from('user_suspensions').select('*').eq('user_id', userId).maybeSingle();
  return data || null;
}
